import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";

interface Props {
  currentPage: number;
  hasMorePages: boolean;
  onChange: (next: number) => void;
}

export const PagePagination = ({
  currentPage,
  hasMorePages,
  onChange,
}: Props) => {
  let pages = [currentPage];
  if (currentPage > 0) {
    pages = [currentPage - 1, ...pages];
  }
  if (hasMorePages) {
    pages = [...pages, currentPage + 1];
  }

  return (
    <Pagination className="mt-10 pb-10">
      <PaginationContent>
        {currentPage > 0 && (
          <PaginationItem>
            <PaginationPrevious onClick={() => onChange(currentPage - 1)} />
          </PaginationItem>
        )}
        {pages.map((page) => (
          <PaginationItem key={page}>
            <PaginationLink
              isActive={page === currentPage}
              onClick={() => {
                if (currentPage === page) {
                  return;
                }
                onChange(page);
              }}
            >
              {page + 1}
            </PaginationLink>
          </PaginationItem>
        ))}
        {hasMorePages && (
          <PaginationItem>
            <PaginationNext onClick={() => onChange(currentPage + 1)} />
          </PaginationItem>
        )}
      </PaginationContent>
    </Pagination>
  );
};
